import { defineStore } from "pinia";
import { getInstance } from "../api/api";

const api = getInstance();

export const useSchedulingStore = defineStore('scheduling', {
    state: () => {
        return {
            lastDate:null,
            schedulings:[]
        }
    },
    actions: {
        setLastDate(lastDate) {
            this.lastDate = lastDate;
        },
        clear() {
            this.schedulings = [];
        },
        async getSchedulingsByUserId(patientId) {
            try {
                let response = await api.get("v1/Scheduling", { params: {patientId} })
                if (response.data.success) {                    
                    this.schedulings = response.data.data;
                    this.schedulings.sort((a, b) => (b.startDate > a.startDate) ? -1 : ((a.startDate > b.startDate) ? 1 : 0));
                }
            } catch {
                return;
            }
        }
    }
})
